import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getTopMenus } from '../../../../redux/menus/selectors';

const PVMenuLeft = (props) => {
    const { topMenus, leftMenuName } = props;

    function moveCanvasWithoutAnimation(wholeMenu, callback) {
        wholeMenu.classList.remove('pv-nav-animate');
        callback();
    }

    function moveCanvasWithAnimation(wholeMenu, callback) {
        wholeMenu.classList.add('pv-nav-animate');
        callback();
    }

    function moveCanvas(navToMenu) {
        let navToMenu2 = navToMenu;
        if (navToMenu2 === null) {
            navToMenu2 = document.getElementById('LeftMenuShop');
            if (navToMenu2 === null) {
                navToMenu2 = document.getElementById('LeftMenuProducts');
            }
        }
        const navToMenuVerticalOrder = navToMenu2.dataset.order;
        const navToMenuLevel = navToMenu2.parentNode.parentNode;
        const newLevelTop = `${(navToMenuVerticalOrder - 1) * -1200}px`;
        navToMenuLevel.style.top = newLevelTop;

        const navToMenuHorizontalOrder = navToMenuLevel.dataset.order;
        const canvas = document.getElementById('pv-nav-canvas-left');
        const newCanvasLeft = `${(navToMenuHorizontalOrder - 1) * -350}px`;
        canvas.style.left = newCanvasLeft;
    }

    useEffect(() => {
        if (leftMenuName !== '') {
            const navToHref = `#LeftMenu${props.leftMenuName.replace('&', '')}`;
            const navToID = navToHref.substr(1);
            const navToMenu = document.getElementById(navToID);
            moveCanvas(navToMenu);
        }
    }, [leftMenuName]);

    function handleClick(e) {
        const navToHref = e.currentTarget.getAttribute('href');
        if (navToHref === null) {
            return;
        }
        const isMenuNavigation = navToHref.substr(0, 1) === '#';
        const wholeMenu = document.getElementById('pv-nav-menu-left');
        const menuType = e.currentTarget.dataset.menu;

        let isAnimationDesired = false;
        if (menuType === 'main' || menuType === 'sub') {
            isAnimationDesired = false;
        } else {
            isAnimationDesired = true;
        }

        if (menuType === 'main') {
            wholeMenu.classList.remove('is-sub-menu');
            wholeMenu.classList.add('is-main-menu');
        }

        if (menuType === 'sub') {
            wholeMenu.classList.remove('is-main-menu');
            wholeMenu.classList.add('is-sub-menu');
        }

        if (isMenuNavigation) {
            const navToID = navToHref.substr(1);

            if (navToID === 'Close') {
                wholeMenu.style.display = 'none';
            } else {
                wholeMenu.style.display = 'block';
                const navToMenu = document.getElementById(navToID);
                navToMenu.scrollTop = 0;

                if (isAnimationDesired) {
                    moveCanvasWithAnimation(wholeMenu, function move() {
                        moveCanvas(navToMenu);
                    });
                } else {
                    moveCanvasWithoutAnimation(wholeMenu, function move() {
                        moveCanvas(navToMenu);
                    });
                }
            }
            e.preventDefault();
        }
    }

    const renderPvMenuItem = (items) => {
        ////// console.log('*** renderPvMenuItem *** ' + JSON.stringify(items));
        return (
            <div>
                {items.map((item) => {
                    let iconClass = '';

                    if (item.itemClass === 'pv-nav-forward') {
                        iconClass = 'pv-nav-icon-angle-right';
                    } else if (
                        item.itemClass === 'pv-nav-back' ||
                        item.itemClass === 'pv-nav-back-main-only'
                    ) {
                        iconClass = 'pv-nav-icon-angle-left';
                    }

                    if (item.itemPageType === 'React' && item.itemClass === 'pv-nav-item-link') {
                        return (
                            <li key={item.itemID}>
                                <Link
                                    to={item.itemHref}
                                    className={`${item.itemClass} ${iconClass}`}
                                    draggable="false"
                                    onClick={handleClick}
                                    data-menu="sub"
                                >
                                    {item.itemName}
                                </Link>
                            </li>
                        );
                    }

                    return (
                        <li key={item.itemID}>
                            <a
                                href={
                                    item.itemHref != null
                                        ? item.itemHref.replace('#Menu', '#LeftMenu')
                                        : item.itemHref
                                }
                                className={`${item.itemClass} ${iconClass}`}
                                draggable="false"
                                onClick={handleClick}
                            >
                                {item.itemName}
                            </a>
                        </li>
                    );
                })}
            </div>
        );
    };

    const renderPvMenu = (menus) => {
        ////// console.log("*** renderPvMenu *** " + JSON.stringify(menus));
        return (
            <div>
                {menus.map((menu) => {
                    return (
                        <div
                            key={menu.menuID.replace('Menu', 'LeftMenu').replace('&', '')}
                            id={menu.menuID.replace('Menu', 'LeftMenu').replace('&', '')}
                            data-order={menu.menuOrder}
                            data-menu-name={menu.menuName}
                            className={`pv-nav-menu ${menu.menuClass}`}
                            draggable="false"
                        >
                            <ul>{renderPvMenuItem(menu.menuItems)}</ul>
                        </div>
                    );
                })}
            </div>
        );
    };

    const renderPvNavMenuLevel = (levels) => {
        ////// console.log("*** renderPvNavMenuLevel *** " + JSON.stringify(levels));
        return (
            <div id="pv-nav-canvas-left">
                {levels.map((level) => {
                    return (
                        <div key={level.levelID} id={level.levelID} data-order={level.levelOrder}>
                            {renderPvMenu(level.levelMenus)}
                        </div>
                    );
                })}
            </div>
        );
    };

    ////// console.log("*** PVMenuLeft *** " + JSON.stringify(topMenus));
    return (
        <div id="pv-nav">
            <div id="stickyMenu">
                <div id="pv-nav-menu-left">
                    <div id="pv-nav-window">{renderPvNavMenuLevel(topMenus)}</div>
                </div>
            </div>
        </div>
    );
};

PVMenuLeft.propTypes = {
    topMenus: PropTypes.oneOfType([PropTypes.any]).isRequired,
    leftMenuName: PropTypes.string,
};

PVMenuLeft.defaultProps = {
    leftMenuName: 'Shop',
};

const mapStateToProps = (state) => {
    return { topMenus: getTopMenus(state) };
};

export default connect(mapStateToProps, null)(PVMenuLeft);
